import { FormattedMessage } from 'react-intl';

export const ParameterSelect: React.FC<{
  title: string;
  name: string;
  value: string;
  options: Array<{ value: string; label: string }>;
  description?: string | undefined;
  onChange: (e: any) => void;
}> = ({ title, name, value, options, description, onChange }) => (
  <li className="py-2 flex flex-col">
    <div className="flex justify-between items-center">
      <div className="flex items-center">
        <p className="text-black">
          <FormattedMessage id={title} />
        </p>
      </div>
      <select
        name={name}
        onChange={onChange}
        className="appearance-none focus:ring-0 focus:border-0 border-0 text-right text-black font-bold"
        value={value}
      >
        {options.map((o, idx) => (
          <option
            key={idx}
            value={o.value}
            className="hover:bg-primary text-black"
          >
            {o.label}
          </option>
        ))}
      </select>
    </div>
    {description && <p className="text-xs text-gray-500">{description}</p>}
  </li>
);
